class ReadMore {
    constructor(domElement, options) {
        this.options = Object.assign({
            content_hidden_default: true,
            hidden_height: 100,
            read_more_label: 'Read More',
            read_less_label: 'Read Less',
            label_text_align: 'center',
        }, options);

        this.domElement = domElement;
        this.rootDomElement = null;
        this.wrapperDomElement = null;
        this.toggleDomElement = null;

        this.contentHidden = this.options['content_hidden_default'];

        this.wrapDomElement();
        this.reflectStatusToDom();
    }

    onToggleClick(e) {
        e.preventDefault();

        this.contentHidden = !this.contentHidden;
        this.reflectStatusToDom();
    }

    reflectStatusToDom() {
        this.toggleDomElement.innerHTML = '';

        if (this.contentHidden) {
            this.toggleDomElement.appendChild(
                document.createTextNode(this.options['read_more_label']));

            this.wrapperDomElement.style.height = isNaN(
                this.options['hidden_height']) ?
                this.options['hidden_height'] :
                this.options['hidden_height'] + 'px';
            this.rootDomElement.classList.remove('content-visible');
        } else {
            this.toggleDomElement.appendChild(
                document.createTextNode(this.options['read_less_label']));

            this.wrapperDomElement.style.height = '';
            this.rootDomElement.classList.add('content-visible');
        }
    }

    wrapDomElement() {
        this.rootDomElement = document.createElement('div');
        this.rootDomElement.className = 'brevis-readmore';

        this.wrapperDomElement = document.createElement('div');
        this.wrapperDomElement.className = 'brevis-readmore-wrapper';

        this.toggleDomElement = document.createElement('a');
        this.toggleDomElement.className = 'brevis-readmore-toggle';
        this.toggleDomElement.style.textAlign = this.options.label_text_align;
        this.toggleDomElement.href = 'javascript://';
        this.toggleDomElement.addEventListener('click',
            this.onToggleClick.bind(this));

        this.domElement.parentNode.insertBefore(this.rootDomElement,
            this.domElement);

        this.wrapperDomElement.appendChild(this.domElement);

        this.rootDomElement.appendChild(this.wrapperDomElement);
        this.rootDomElement.appendChild(this.toggleDomElement);
    }
}

export default ReadMore;
